import React, { useState } from 'react';

export interface DialerProps {
  onDial: (number: string) => void;
  disabled: boolean;
}

export function Dialer({ onDial, disabled }: DialerProps): React.JSX.Element {
  const [number, setNumber] = useState('');
  const canCall = !disabled && number.trim().length > 0;
  return (
    <section>
      <label htmlFor="dialer-input">Número</label>
      <input
        id="dialer-input"
        type="tel"
        value={number}
        onChange={(e) => setNumber(e.target.value)}
        placeholder="+34..."
      />
      <button
        type="button"
        disabled={!canCall}
        onClick={() => onDial(number.trim())}
      >
        Llamar
      </button>
    </section>
  );
}
